import {
  ScopeOfPracticeEnum,
  ShiftRequestStatusEnum
} from '@umss/shared/utils';

/**
 * Search parameters for shift requests
 * Matches backend ShiftRequestSearchDto
 */
export interface ShiftRequestSearchDto {
  facilityId?: string;
  facilityIds?: string[];
  corporateId?: string;
  contractorId?: string;
  shiftNeedId?: string;
  statuses?: ShiftRequestStatusEnum[];
  excludeStarted?: boolean;
  startDate?: string; // YYYY-MM-DD
  endDate?: string; // YYYY-MM-DD
  scopeOfPractice?: ScopeOfPracticeEnum;
  pageNumber?: number;
  pageSize?: number;
}
